import { render, staticRenderFns } from "./Backpack.vue?vue&type=template&id=65a89a9b&scoped=true"
import script from "./Backpack.vue?vue&type=script&lang=js"
export * from "./Backpack.vue?vue&type=script&lang=js"
import style0 from "./Backpack.vue?vue&type=style&index=0&id=65a89a9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a89a9b",
  null
  
)

export default component.exports